import {
	MobileNavigationOptionItem,
	NavigationState,
} from 'src/components/Navigation/types';
import { Open } from '@drift-labs/icons';
import NavItemTags from 'src/components/Navigation/NavItemTags';

interface Props {
	categoryOption: MobileNavigationOptionItem;
	handleNavigation: NavigationState['handleNavigation'];
}

export default function MobileNavAccordionContentButton({
	categoryOption,
	handleNavigation,
}: Props) {
	const { key, name, newTag, hotTag, tagLabel, isExternalLink, handler } =
		categoryOption;

	const handleClick = () => {
		handleNavigation(handler());
	};

	return (
		<button
			// `pr-lg` to align with the trigger's chevron.
			className="flex w-full items-center justify-between gap-x-sm py-xl pr-lg pl-3xl text-text-default"
			onClick={handleClick}
			data-testid={`mobile-nav-${key}`}
		>
			<span className="typo-t3">{name}</span>
			{isExternalLink && <Open autoSize />}
			<NavItemTags newTag={newTag} hotTag={hotTag} tagLabel={tagLabel} />
		</button>
	);
}
